import React from 'react';

export default function Home({ onStartGame }) {
  return (
    <div className="relative h-full w-full">
      {/* Background Image */}
      <div className="absolute inset-0 bg-[url('/assets/locations/forestClearing.png')] bg-cover bg-center" />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/60 to-black/80 pointer-events-none" />

      {/* Content Container */}
      <div className="relative h-full w-full flex flex-col items-center justify-center p-4">
        {/* Title with floating animation */}
        <h1 
          className="text-5xl font-bold mb-6 text-white text-center font-['Crimson_Pro'] 
            tracking-wide pointer-events-none
            animate-[float_4s_ease-in-out_infinite]
            [text-shadow:_0_0_20px_rgba(255,255,255,0.4)]"
        >
          Oliver's Woodland Adventure
        </h1>
        
        {/* Description */}
        <p className="text-lg font-['Quicksand'] text-gray-200 mb-12 text-center 
          max-w-xs leading-relaxed pointer-events-none
          [text-shadow:_0_0_10px_rgba(255,255,255,0.3)]"
        >
          Explore the mysterious woods of Minnesota and uncover its hidden secrets
        </p>

        {/* Button with hover effects and animation */}
        <button
          onClick={onStartGame}
          className="px-10 py-4 text-lg font-['Quicksand'] font-semibold
            bg-gradient-to-br from-emerald-700 to-emerald-900
            hover:from-emerald-600 hover:to-emerald-800
            text-white rounded-lg transition-all duration-300
            shadow-[0_0_20px_rgba(16,185,129,0.3)]
            hover:shadow-[0_0_30px_rgba(16,185,129,0.5)]
            animate-[pulse_2s_ease-in-out_infinite]
            transform hover:scale-105"
        >
          Begin Adventure
        </button>
      </div>

      {/* Add keyframes for animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.8; }
        }
      `}</style>
    </div>
  );
}
